<template>
  <h5 class="w-full text-left text-xxs font-bold uppercase">
    {{ title }}
  </h5>
  <div
    v-if="items.length"
    class="my-4 grid grid-cols-1 gap-4"
  >
    <div
      v-for="(item, index) in items"
      :key="index"
      class="flex flex-col justify-start self-center pl-2 text-left"
      :class="[
        { 'border-b-2 pb-2': needsBorder(++index) },
        index <= itemsToShow || showMore ? 'visible' : 'hidden',
      ]"
    >
      <p class="text-body-color">
        {{ item.masked_email }}
      </p>
      <p class="text-body-color">
        {{ item.masked_phone }}
      </p>
    </div>
  </div>
  <div v-else>No data found</div>
  <div
    v-if="items.length > itemsToShow"
    class="mb-4 flex justify-start"
  >
    <button-main
      class="cursor-pointer text-sm text-yellow-500 underline"
      variant="link"
      @click="toggleShowMore"
    >
      {{ showMore ? 'Show less' : 'Show more' }}
    </button-main>
  </div>
</template>

<script>
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'RequestRecipients',
  components: {
    ButtonMain,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    itemsToShow: {
      type: Number,
      default: 1,
    },
    items: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showMore: false,
    };
  },
  computed: {
    needsBorder() {
      return (index) => {
        if (this.showMore) {
          return index !== this.items.length;
        }
        return index !== this.itemsToShow;
      };
    },
  },
  methods: {
    toggleShowMore() {
      this.showMore = !this.showMore;
    },
  },
};
</script>
